import { styled, Tooltip as BaseTooltip, tooltipClasses, TooltipProps } from "@mui/material";

export const Tooltip = styled(({ className, ...props }: TooltipProps) => <BaseTooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontWeight: 400,
    fontSize: theme.typography.size.small,
    padding: theme.spacing(1),
  },
}));
